export interface Store {
  id: string;
  name: string;
  address: string;
  district: string;
  distance: string;
  distanceNum: number;
  status: 'open' | 'closed' | 'closing-soon';
  hours: string;
  phone: string;
  amenities: string[];
  lat: number;
  lng: number;
  driveThru: boolean;
  wifi: boolean;
  outdoor: boolean;
  parkingAvailable: boolean;
}

export const stores: Store[] = [
  {
    id: 'store-001',
    name: 'Gloria Jean\'s Taksim',
    address: 'İstiklal Caddesi No:40, Beyoğlu',
    district: 'Beyoğlu',
    distance: '0,3 km',
    distanceNum: 0.3,
    status: 'open',
    hours: '07:00 – 23:00',
    phone: '+90 212 293 44 11',
    amenities: ['WiFi', 'Dış Alan', 'Engelli Erişimi'],
    lat: 41.033,
    lng: 28.977,
    driveThru: false,
    wifi: true,
    outdoor: true,
    parkingAvailable: false,
  },
  {
    id: 'store-002',
    name: 'Gloria Jean\'s Nişantaşı',
    address: 'Abdi İpekçi Caddesi No:18, Şişli',
    district: 'Şişli',
    distance: '1,2 km',
    distanceNum: 1.2,
    status: 'open',
    hours: '07:30 – 22:30',
    phone: '+90 212 296 88 22',
    amenities: ['WiFi', 'Drive-Thru Yok', 'Otopark'],
    lat: 41.047,
    lng: 28.993,
    driveThru: false,
    wifi: true,
    outdoor: false,
    parkingAvailable: true,
  },
  {
    id: 'store-003',
    name: 'Gloria Jean\'s Beşiktaş',
    address: 'Barbaros Bulvarı No:125, Beşiktaş',
    district: 'Beşiktaş',
    distance: '2,1 km',
    distanceNum: 2.1,
    status: 'closing-soon',
    hours: '07:00 – 22:00',
    phone: '+90 212 258 77 33',
    amenities: ['WiFi', 'Drive-Thru', 'Dış Alan', 'Otopark'],
    lat: 41.042,
    lng: 29.003,
    driveThru: true,
    wifi: true,
    outdoor: true,
    parkingAvailable: true,
  },
  {
    id: 'store-004',
    name: 'Gloria Jean\'s Kadıköy',
    address: 'Moda Caddesi No:42, Kadıköy',
    district: 'Kadıköy',
    distance: '3,5 km',
    distanceNum: 3.5,
    status: 'open',
    hours: '08:00 – 23:30',
    phone: '+90 216 414 55 44',
    amenities: ['WiFi', 'Dış Alan'],
    lat: 40.988,
    lng: 29.027,
    driveThru: false,
    wifi: true,
    outdoor: true,
    parkingAvailable: false,
  },
  {
    id: 'store-005',
    name: 'Gloria Jean\'s Levent',
    address: 'Büyükdere Caddesi No:201, Levent',
    district: 'Beşiktaş',
    distance: '4,8 km',
    distanceNum: 4.8,
    status: 'open',
    hours: '07:00 – 22:00',
    phone: '+90 212 282 33 55',
    amenities: ['WiFi', 'Drive-Thru', 'Otopark', 'Engelli Erişimi'],
    lat: 41.079,
    lng: 29.010,
    driveThru: true,
    wifi: true,
    outdoor: false,
    parkingAvailable: true,
  },
  {
    id: 'store-006',
    name: 'Gloria Jean\'s Üsküdar',
    address: 'Hakimiyet-i Milliye Caddesi No:8, Üsküdar',
    district: 'Üsküdar',
    distance: '5,2 km',
    distanceNum: 5.2,
    status: 'closed',
    hours: '08:00 – 21:00',
    phone: '+90 216 553 22 66',
    amenities: ['WiFi', 'Boğaz Manzarası'],
    lat: 41.022,
    lng: 29.015,
    driveThru: false,
    wifi: true,
    outdoor: true,
    parkingAvailable: false,
  },
];